import { render, staticRenderFns } from "./SupplierOnboardingFirstCheckPoint.vue?vue&type=template&id=0f242bdb&"
import script from "./SupplierOnboardingFirstCheckPoint.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingFirstCheckPoint.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingFirstCheckPoint.vue?vue&type=style&index=0&id=0f242bdb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports